import { Injectable, inject } from '@angular/core';
import { Globals } from '../../globals.service';
import { DialogService } from './dialog.service';
import { HttpErrorResponse } from '@angular/common/http';
declare const $: any;

@Injectable({
  providedIn: 'root',
})
export class NotificationService {
  private globals = inject(Globals);
  private dialogService = inject(DialogService);

  unknownError = 'Unknown error occurred. :('; //TODO nyelvesites
  private longErrors: string[] = ['STORAGE_CANT_CLOSE'];
  showError(error: HttpErrorResponse) {
    if (this.globals.DEBUG_MODE) {
      this.dialogService.showDebugErrorDialog(error);
    }
    if (
      error === undefined ||
      error.error === undefined ||
      error.error.userMessage === undefined ||
      error.error.userMessage === null ||
      error.error.userMessage === ''
    ) {
      if (error.status === 0 && !navigator.onLine) {
        this.showNotification(NotificationType.INFO, 'Ön jelenleg nem csatlakozik az internethez.');
      } else {
        this.showNotification(NotificationType.ERROR, this.unknownError);
      }
    } else {
      this.showNotification(NotificationType.ERROR, error.error.userMessage, error.error.fault);
    }
  }

  showNotification(type: NotificationType, text: string, fault?: string) {
    let bgColor = 'bg-green';

    switch (type) {
      case NotificationType.INFO:
        bgColor = 'bg-light-blue';
        break;
      case NotificationType.ERROR:
        bgColor = 'bg-red';
        break;
      case NotificationType.WARNING:
        bgColor = 'bg-amber';
        break;
      case NotificationType.SUCCESS:
        bgColor = 'bg-green';
        break;
    }

    this.show(bgColor, text, fault);
  }

  private show(colorName = null, text = null, fault = null, animateEnter = null, animateExit = null) {
    if (text === null || text === '') {
      text = 'please specify alert text';
    }
    if (animateEnter === null || animateEnter === '') {
      animateEnter = 'animated zoomIn';
    }
    if (animateExit === null || animateExit === '') {
      animateExit = 'animated zoomOutRight';
    }
    const allowDismiss = true;
    if (this.longErrors.find((x) => x === fault)) {
      $.notify(
        {
          message: text,
        },
        {
          type: colorName,
          allow_dismiss: allowDismiss,
          newest_on_top: true,
          timer: 7000,
          animate: {
            enter: animateEnter,
            exit: animateExit,
          },
          template:
            '<div data-notify="container" class="bootstrap-notify-container alert alert-dismissible {0} ' +
            (allowDismiss ? 'p-r-35' : '') +
            '" role="alert">' +
            '<button type="button" aria-hidden="true" class="close" data-notify="dismiss"  style="z-index:100005 !important">×</button>' +
            '<span data-notify="icon"></span> ' +
            '<span data-notify="title">{1}</span> ' +
            '<span data-notify="message">{2}</span>' +
            '</div>',
        }
      );
    } else {
      $.notify(
        {
          message: text,
        },
        {
          type: colorName,
          allow_dismiss: allowDismiss,
          newest_on_top: true,
          timer: 1000,
          animate: {
            enter: animateEnter,
            exit: animateExit,
          },
          template:
            '<div data-notify="container" class="bootstrap-notify-container alert alert-dismissible {0} ' +
            (allowDismiss ? 'p-r-35' : '') +
            '" role="alert">' +
            '<button type="button" aria-hidden="true" class="close" data-notify="dismiss"  style="z-index:100005 !important">×</button>' +
            '<span data-notify="icon"></span> ' +
            '<span data-notify="title">{1}</span> ' +
            '<span data-notify="message">{2}</span>' +
            '</div>',
        }
      );
    }
  }
}

export enum NotificationType {
  INFO = 0,
  ERROR = 1,
  WARNING = 2,
  SUCCESS = 3,
}
